import { FileTypeName } from 'api/types/entity';
import {
  IdentityDocumentParam,
  IdentityDocumentWithFilesParam,
} from 'api/types/params';
import { lodash } from 'helpers';

import { IdentityDocumentFormType } from '../../forms/identityDocumentForm';
import { IdentityDocumentFormType as IdentityDocumentWithFilesFormType } from '../../forms/identityDocumentWithFilesForm';

export const parseIdentityDocumentParam = (
  data: IdentityDocumentFormType
): IdentityDocumentParam => ({
  authority: data.identityDocument.authority,
  dateOfIssue: data.identityDocument.dateOfIssue ?? undefined,
  documentType: data.identityDocument.documentType?.value,
  expirationDate: data.identityDocument.expirationDate ?? undefined,
  number: data.identityDocument.number,
  сountryOfIssue: data.identityDocument.countryOfIssue ?? undefined,
});

export const parseIdentityDocumentWithFilesParam = (
  data: IdentityDocumentWithFilesFormType
): IdentityDocumentWithFilesParam => ({
  authority: data.identityDocument.authority,
  dateOfIssue: data.identityDocument.dateOfIssue ?? undefined,
  documentType: data.identityDocument.documentType?.value,
  expirationDate: data.identityDocument.expirationDate ?? undefined,
  number: data.identityDocument.number,
  сountryOfIssue: data.identityDocument.countryOfIssue ?? undefined,
  fileIds: lodash.compact(
    data.identityDocument.files
      ?.filter((file) => file.type === FileTypeName.IdentityDocument)
      .map((file) => file.id)
  ),
});
